module.exports = __webpack_public_path__ + "img/orlando-pirates.b5d7a0b2.png";